"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
exports.linkCellClass = data_catalog_shared_1.cssClass('linkCell', data_catalog_shared_1.elideTextStyle, data_catalog_shared_1.cellPaddingStyle, { display: 'flex' });
exports.noPaddingLinkCellClass = data_catalog_shared_1.cssClass('noPaddingLinkCell', data_catalog_shared_1.elideTextStyle, { display: 'flex' });
var linkContainerClass = data_catalog_shared_1.cssClass('linkContainerClass', {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
var postIconClass = data_catalog_shared_1.cssClass('postIconClass', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '8px',
});
function LinkCellFormatter(_a) {
    var text = _a.text, pathname = _a.pathname, noPadding = _a.noPadding, _b = _a.targetBlank, targetBlank = _b === void 0 ? false : _b, _c = _a.useAnchor, useAnchor = _c === void 0 ? false : _c, _d = _a.postIcon, postIcon = _d === void 0 ? null : _d, _e = _a.linkTitle, linkTitle = _e === void 0 ? null : _e;
    return (React.createElement("div", { className: noPadding ? exports.noPaddingLinkCellClass : exports.linkCellClass },
        React.createElement("div", { className: linkContainerClass }, useAnchor
            ? anchorContents({ text: text, pathname: pathname, noPadding: noPadding, targetBlank: targetBlank, postIcon: postIcon, linkTitle: linkTitle })
            : linkContents({ text: text, pathname: pathname, noPadding: noPadding, targetBlank: targetBlank, postIcon: postIcon, linkTitle: linkTitle })),
        postIcon
            ? React.createElement("div", { className: postIconClass }, postIcon)
            : null));
}
exports.LinkCellFormatter = LinkCellFormatter;
function anchorContents(_a) {
    var text = _a.text, pathname = _a.pathname, noPadding = _a.noPadding, targetBlank = _a.targetBlank, postIcon = _a.postIcon, linkTitle = _a.linkTitle;
    var _b;
    return (React.createElement("a", { className: data_catalog_shared_1.linkClass, href: pathname, title: (_b = (linkTitle !== null && linkTitle !== void 0 ? linkTitle : text), (_b !== null && _b !== void 0 ? _b : undefined)), target: targetBlank ? '_blank' : undefined }, text));
}
function linkContents(_a) {
    var text = _a.text, pathname = _a.pathname, noPadding = _a.noPadding, targetBlank = _a.targetBlank, postIcon = _a.postIcon, linkTitle = _a.linkTitle;
    var _b;
    return (React.createElement(react_router_dom_1.Link, { className: data_catalog_shared_1.linkClass, to: pathname, title: (_b = (linkTitle !== null && linkTitle !== void 0 ? linkTitle : text), (_b !== null && _b !== void 0 ? _b : undefined)), target: targetBlank ? '_blank' : undefined }, text));
}
function createLinkCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, useAnchor, getIconFromRowData, getLinkTitleFromRowData) {
    if (noPadding === void 0) { noPadding = false; }
    if (useAnchor === void 0) { useAnchor = false; }
    if (getIconFromRowData === void 0) { getIconFromRowData = function (rowData) { return null; }; }
    if (getLinkTitleFromRowData === void 0) { getLinkTitleFromRowData = function (rowData) { return null; }; }
    return function (props) { return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(LinkCellFormatter, { text: getTextFromRowData(props.row.data), pathname: getPathFromRowData(urls, props.row.data), noPadding: noPadding, useAnchor: useAnchor, postIcon: getIconFromRowData(props.row.data), linkTitle: getLinkTitleFromRowData(props.row.data) });
    })); };
}
exports.createLinkCellFormatter = createLinkCellFormatter;
function createLinkOrTextCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, targetBlank, useAnchor) {
    if (noPadding === void 0) { noPadding = false; }
    if (targetBlank === void 0) { targetBlank = false; }
    if (useAnchor === void 0) { useAnchor = false; }
    return function (props) { return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        var text = getTextFromRowData(props.row.data);
        var url = getPathFromRowData(urls, props.row.data);
        if (url) {
            return React.createElement(LinkCellFormatter, { text: text, pathname: url, noPadding: noPadding, targetBlank: targetBlank, useAnchor: useAnchor });
        }
        else {
            return React.createElement(data_catalog_shared_1.TextCellFormatter, { text: text, noPadding: noPadding });
        }
    })); };
}
exports.createLinkOrTextCellFormatter = createLinkOrTextCellFormatter;
//# sourceMappingURL=LinkCellFormatter.js.map